export const fontVersion = (variant) => {
  const skuIsPro = variant.sku.endsWith('pro');

  return skuIsPro ? 'pro' : 'std';
};

export const fontIsPro = (variant) => {
  return fontVersion(variant) === 'pro';
};
